// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-group-tabs .v-tabs .v-tab{text-transform:none!important;font-size:1.125rem;letter-spacing:normal;border-bottom:1px solid #d1d5d8}", ""]);
// Exports
module.exports = exports;
